import { render, staticRenderFns } from "./HorseCreation.vue?vue&type=template&id=0eed9aee&"
import script from "./HorseCreation.vue?vue&type=script&lang=js&"
export * from "./HorseCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports